// Editorial content for The Smiling Roots — testimonials + manifesto.
// Product catalog moved to MongoDB (see /api/products + ProductsContext).

export const testimonials = [
  {
    quote: "The best tasting wellness drink I've ever had.",
    author: "Marion K.",
    place: "Silver Lake",
  },
  {
    quote: "You can taste the quality — every bottle feels considered.",
    author: "Eliot B.",
    place: "Ferry Plaza",
  },
  {
    quote: "My entire family loves these. It became a ritual.",
    author: "Ana R.",
    place: "Union Square",
  },
  {
    quote: "Understated, elegant, and genuinely delicious.",
    author: "James O.",
    place: "Pike Place",
  },
];

export const manifesto = [
  {
    number: "01",
    label: "Origin",
    title: "Small hands, small batches.",
    body:
      "Every bottle is composed by a small team who still weigh, taste and pour. Nothing is scaled beyond what care allows.",
  },
  {
    number: "02",
    label: "Sourcing",
    title: "Ingredients chosen slowly.",
    body:
      "We travel to meet the growers. What arrives at our door is what arrives in your bottle — nothing borrowed, nothing rushed.",
  },
  {
    number: "03",
    label: "Craft",
    title: "Time as an ingredient.",
    body:
      "Cold pressing, slow steeping, deliberate resting. We treat time as a raw material — because it is.",
  },
  {
    number: "04",
    label: "Ritual",
    title: "A drink is a small pause.",
    body:
      "The glass in your hand is a punctuation mark in the day. We design for the pause, and for what follows it.",
  },
];
